/**
 * Design System Yoco - Tokens Espacement
 *
 * REGLES:
 * - Base unit = 4px
 * - Utiliser multiples de 4: 4, 8, 12, 16, 20, 24, 32, 40, 48
 */

// ==============================================
// SPACING (base 4px)
// ==============================================
export const spacing = {
  0: '0',
  1: '4px',
  2: '8px',
  3: '12px',
  4: '16px',
  5: '20px',
  6: '24px',
  8: '32px',
  10: '40px',
  12: '48px',
};

// ==============================================
// BORDER RADIUS - Plus petit, plus propre
// ==============================================
export const radius = {
  none: '0',
  sm: '4px',
  md: '6px',
  lg: '8px',
  xl: '12px',
  full: '9999px',
};

// ==============================================
// SHADOWS - Tres subtils, presque invisibles
// ==============================================
export const shadows = {
  none: 'none',
  sm: '0 1px 2px rgba(0, 0, 0, 0.04)',
  md: '0 2px 4px rgba(0, 0, 0, 0.06)',
  lg: '0 4px 8px rgba(0, 0, 0, 0.08)',
};

// ==============================================
// SIDEBAR DIMENSIONS
// ==============================================
export const sidebar = {
  width: 240,
  collapsedWidth: 64,
  headerHeight: 64,
};

// ==============================================
// LAYOUT DIMENSIONS
// ==============================================
export const layout = {
  maxWidth: 1200,
  contentPadding: 24,
};

// ==============================================
// MOBILE DIMENSIONS
// ==============================================
export const mobile = {
  // Navigation
  bottomNavHeight: 64,
  headerHeight: 56,

  // Content padding
  pagePadding: 16,
  cardPadding: 16,

  // Touch targets (Apple HIG minimum)
  minTouchTarget: 44,
  touchPadding: 12,

  // Safe areas (CSS env variables)
  safeAreaTop: 'env(safe-area-inset-top)',
  safeAreaBottom: 'env(safe-area-inset-bottom)',
  safeAreaLeft: 'env(safe-area-inset-left)',
  safeAreaRight: 'env(safe-area-inset-right)',
};

// ==============================================
// BREAKPOINTS (matching MUI defaults)
// ==============================================
export const breakpoints = {
  xs: 0,      // Mobile portrait
  sm: 600,    // Mobile landscape / small tablet
  md: 900,    // Tablet
  lg: 1200,   // Desktop
  xl: 1536,   // Large desktop
};

const spacingTokens = { spacing, radius, shadows, sidebar, layout, mobile, breakpoints };
export default spacingTokens;
